module.exports = __webpack_public_path__ + "media/images/emoticons/faxto-f31d2284e502da688f45abd64cf86f4f.gif";